import React from 'react';

// Components
import ModalV2 from '@/views/components/modals/ModalV2';
import { DeleteBody } from './components';

// Types
import HistoricalScenario from '@/types/historical-scenario';
import { UUID } from '@/types/global';

interface DeleteModalProps {
  customScenario: HistoricalScenario;
  onClose: () => void;
  onConfirm: (id: UUID) => void;
  show: boolean;
  isLoading: boolean;
}

export const DeleteModal: React.FC<DeleteModalProps> = ({ customScenario, onClose, onConfirm, show, isLoading }) => {
  const i18nBasePath = 'Comparison.HistoricalScenarios.DeleteModal';
  return (
    <ModalV2
      body={<DeleteBody customScenario={customScenario} i18nBasePath={i18nBasePath} onClose={onClose} onConfirm={onConfirm} isLoading={isLoading} />}
      onClose={onClose}
      show={show}
      title={`${i18nBasePath}.Title`}
    />
  );
};
